"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function FoodTruck(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M4 7v9.787A2.975 2.975 0 0 1 6 16c1.293 0 2.395.843 2.813 2h5.374c.418-1.157 1.52-2 2.813-2 1.293 0 2.395.843 2.813 2H21v-4.28l-2.316-.77A1 1 0 0 1 18 12V7h1a1 1 0 0 1 1 1v3.28l2.316.77A1 1 0 0 1 23 13v5c0 1.093-.907 2-2 2h-1.188c-.417 1.157-1.519 2-2.812 2s-2.395-.843-2.813-2H8.814c-.418 1.157-1.52 2-2.813 2-1.373 0-2.533-.948-2.883-2.217A2.01 2.01 0 0 1 2 18V8a1 1 0 0 1 1-1h1zm2 11c-.564 0-1 .436-1 1 0 .564.436 1 1 1 .564 0 1-.436 1-1 0-.564-.436-1-1-1zm11 0c-.564 0-1 .436-1 1 0 .564.436 1 1 1 .564 0 1-.436 1-1 0-.564-.436-1-1-1zM14.068 4l.178.008c.46.039.883.217 1.207.54.862.863.688 2.436-.39 3.514-.758.758-1.757 1.06-2.586.877L12.414 9 16 12.586 14.586 14 11 10.414 7.414 14 6 12.586l5.063-5.063c-.183-.828.118-1.827.876-2.585.674-.674 1.54-.995 2.307-.93zM6.89 3.477l2.963 2.962-1.903 1.9-1.201-1.2a2.491 2.491 0 0 1 0-3.524l.14-.138z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = FoodTruck;
